import {BlockType, Blocks} from '../blocks/Blocks'
import {Hero, HeroType} from '../layout/Hero'
import {MainUrlTypes, PageData} from '../../types'

import {Breadcrumbs} from '../layout/Breadcrumbs'
import {CardSwitchType} from '../layout/cards/CardSwitch'
import {Layout} from '../layout/Layout'
import React from 'react'
import {style} from '../../util/style'
import {wrap} from '@codeurs/front'

const styles = style('fullpage')

export type FullpageType = {
	hero: HeroType
	blocks?: Array<BlockType>
	main_pages?: Array<MainUrlTypes>
	news?: Array<CardSwitchType>
}

export const Fullpage: React.FC<PageData & FullpageType> = wrap(Layout)(
	({...props}) => {
		const {parents, title, hero, blocks, main_pages, news} = props

		return (
			<div className={styles()}>
				<Hero {...hero} title={(hero && hero.title) || title} />
				<Breadcrumbs parents={parents} title={title} />
				<Blocks
					blocks={blocks}
					container={true}
					fullwidth={true}
					main_pages={main_pages}
					news={news}
				/>
			</div>
		)
	}
)
